import { AssessmentsMenuBase } from "@/ui-components/layouts/components/AssessmentsMenu/AssessmentsMenuBase";

const linkGenerator = (assessmentId: string, siteAssessmentId: string, id: string) =>
  `/assessments/${assessmentId}/${siteAssessmentId}/${id}/review`;

export const AssessmentsReviewMenu = () => <AssessmentsMenuBase linkGenerator={linkGenerator} mode="reviewer" />;
